/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Inspectors_TitleInputs */



/**
* | output |
* | --- |
* | "Seafarers first, inspectors second." |
*
* @param {Team_Inspectors_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_inspectors_title = /** @type {((inputs?: Team_Inspectors_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Inspectors_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("先是海员，再是检查员。")
	return /** @type {LocalizedString} */ ("Seafarers first, inspectors second.")
});